// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.device-list-page-bg {
    background-color: #f9f9f9;
    min-height: 100vh;
    padding: 20px 0;
}

.dl-container { 
    width: 90%; 
    max-width: 1100px;
    margin: auto; 
}

.dl-header-card {
    background: #1e293e;
    padding: 10px;
    border-radius: 10px;
    border: 1px solid #334155;
    text-align: center;
}

.dl-title { color: #f8fafc; margin-bottom: 15px; font-size: 1.5rem; }

.dl-header-actions {
    display: flex;
    gap: 10px;
    justify-content: center;
    flex-wrap: wrap;
}

.dl-search-input {
    flex: 1 1;
    min-width: 200px;
    max-width: 400px;
    padding: 10px 15px;
    border-radius: 8px;
    border: 1px solid #334155;
    background: #0f172a;
    color: white;
    outline: none;
}

/* List Item */
.dl-item {
    background: #1e293b;
    margin-top: 15px;
    border-radius: 10px;
    border: 1px solid #334155;
    padding: 15px 20px;
}

.dl-item-main {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.dl-info { display: flex; align-items: center; gap: 12px; }

.dl-status-dot { width: 10px; height: 10px; border-radius: 50%; }
.dl-status-dot.online { background: #22c55e; box-shadow: 0 0 8px #22c55e; }
.dl-status-dot.offline { background: #ef4444; box-shadow: 0 0 8px #ef4444; }
.dl-status-dot.checking { background: #eab308; }

.dl-hostname { color: #f8fafc; font-size: 1rem; }
.dl-status-text { font-size: 0.85rem; }
.text-online { color: #4ade80; }
.text-offline { color: #f87171; }

/* Buttons */
.dl-actions { display: flex; gap: 8px; align-items: center;  }
.dl-desktop-only-btns { display: flex; gap: 8px; }

.dl-btn {
    border: none;
    max-width: 1000px;
    padding: 7px 15px;
    border-radius: 6px;
    cursor: pointer;
    color: white;
    font-weight: 600;
    font-size: 0.8rem;
    transition: 0.2s;
    white-space: nowrap;
}

.dl-btn.info { background: #475569; max-width: 100px; }
.dl-btn.edit { background: #3b82f6; max-width: 100px; }
.dl-btn.delete { background: #ef4444; }
.dl-btn.login { background: #10b981; max-width: 150px; }
.dl-btn.refresh { background: #f59e0b; }

.dl-btn:hover:not(:disabled) { opacity: 0.8; transform: translateY(-1px); }

/* Details Box */
.dl-details-box {
    margin-top: 15px;
    padding-top: 15px;
    border-top: 1px solid #334155;
}

.details-grid {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 8px;
    color: #94a3b8;
    font-size: 0.95rem;
}

/* Mobile Actions (FIXED SIZE) */
.dl-mobile-actions {
    display: flex;
    justify-content: center;
    gap: 10px;
    margin-top: 15px;
}

.dl-mobile-actions .dl-btn {
    flex: 0 1 auto;
    min-width: 120px;
    padding: 8px 20px;
    text-align: center;
}
/* Responsive */
@media (max-width: 768px) {
    .dl-desktop-only-btns { display: none; }
    .dl-item-main { flex-direction: row; }
    .dl-mobile-actions { justify-content: space-around; }
    .dl-mobile-actions .dl-btn { flex: 1 1; max-width: 150px; }
    .details-grid { grid-template-columns: 1fr; }
}`, "",{"version":3,"sources":["webpack://./src/components/DeviceManage/DeviceList.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA,YAAY,cAAc,EAAE,mBAAmB,EAAE,iBAAiB,EAAE;;AAEpE;IACI,aAAa;IACb,SAAS;IACT,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,SAAO;IACP,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;IACZ,aAAa;AACjB;;AAEA,cAAc;AACd;IACI,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA,WAAW,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE;;AAE1D,iBAAiB,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE;AAChE,wBAAwB,mBAAmB,EAAE,2BAA2B,EAAE;AAC1E,yBAAyB,mBAAmB,EAAE,2BAA2B,EAAE;AAC3E,0BAA0B,mBAAmB,EAAE;;AAE/C,eAAe,cAAc,EAAE,eAAe,EAAE;AAChD,kBAAkB,kBAAkB,EAAE;AACtC,eAAe,cAAc,EAAE;AAC/B,gBAAgB,cAAc,EAAE;;AAEhC,YAAY;AACZ,cAAc,aAAa,EAAE,QAAQ,EAAE,mBAAmB,GAAG;AAC7D,wBAAwB,aAAa,EAAE,QAAQ,EAAE;;AAEjD;IACI,YAAY;IACZ,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA,eAAe,mBAAmB,EAAE,gBAAgB,EAAE;AACtD,eAAe,mBAAmB,EAAE,gBAAgB,EAAE;AACtD,iBAAiB,mBAAmB,EAAE;AACtC,gBAAgB,mBAAmB,EAAE,gBAAgB,EAAE;AACvD,kBAAkB,mBAAmB,EAAE;;AAEvC,+BAA+B,YAAY,EAAE,2BAA2B,EAAE;;AAE1E,gBAAgB;AAChB;IACI,gBAAgB;IAChB,iBAAiB;IACjB,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,QAAQ;IACR,cAAc;IACd,kBAAkB;AACtB;;AAEA,gCAAgC;AAChC;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;AACtB;AACA,eAAe;AACf;IACI,wBAAwB,aAAa,EAAE;IACvC,gBAAgB,mBAAmB,EAAE;IACrC,qBAAqB,6BAA6B,EAAE;IACpD,6BAA6B,SAAO,EAAE,gBAAgB,EAAE;IACxD,gBAAgB,0BAA0B,EAAE;AAChD","sourcesContent":[".device-list-page-bg {\n    background-color: #f9f9f9;\n    min-height: 100vh;\n    padding: 20px 0;\n}\n\n.dl-container { \n    width: 90%; \n    max-width: 1100px;\n    margin: auto; \n}\n\n.dl-header-card {\n    background: #1e293e;\n    padding: 10px;\n    border-radius: 10px;\n    border: 1px solid #334155;\n    text-align: center;\n}\n\n.dl-title { color: #f8fafc; margin-bottom: 15px; font-size: 1.5rem; }\n\n.dl-header-actions {\n    display: flex;\n    gap: 10px;\n    justify-content: center;\n    flex-wrap: wrap;\n}\n\n.dl-search-input {\n    flex: 1;\n    min-width: 200px;\n    max-width: 400px;\n    padding: 10px 15px;\n    border-radius: 8px;\n    border: 1px solid #334155;\n    background: #0f172a;\n    color: white;\n    outline: none;\n}\n\n/* List Item */\n.dl-item {\n    background: #1e293b;\n    margin-top: 15px;\n    border-radius: 10px;\n    border: 1px solid #334155;\n    padding: 15px 20px;\n}\n\n.dl-item-main {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.dl-info { display: flex; align-items: center; gap: 12px; }\n\n.dl-status-dot { width: 10px; height: 10px; border-radius: 50%; }\n.dl-status-dot.online { background: #22c55e; box-shadow: 0 0 8px #22c55e; }\n.dl-status-dot.offline { background: #ef4444; box-shadow: 0 0 8px #ef4444; }\n.dl-status-dot.checking { background: #eab308; }\n\n.dl-hostname { color: #f8fafc; font-size: 1rem; }\n.dl-status-text { font-size: 0.85rem; }\n.text-online { color: #4ade80; }\n.text-offline { color: #f87171; }\n\n/* Buttons */\n.dl-actions { display: flex; gap: 8px; align-items: center;  }\n.dl-desktop-only-btns { display: flex; gap: 8px; }\n\n.dl-btn {\n    border: none;\n    max-width: 1000px;\n    padding: 7px 15px;\n    border-radius: 6px;\n    cursor: pointer;\n    color: white;\n    font-weight: 600;\n    font-size: 0.8rem;\n    transition: 0.2s;\n    white-space: nowrap;\n}\n\n.dl-btn.info { background: #475569; max-width: 100px; }\n.dl-btn.edit { background: #3b82f6; max-width: 100px; }\n.dl-btn.delete { background: #ef4444; }\n.dl-btn.login { background: #10b981; max-width: 150px; }\n.dl-btn.refresh { background: #f59e0b; }\n\n.dl-btn:hover:not(:disabled) { opacity: 0.8; transform: translateY(-1px); }\n\n/* Details Box */\n.dl-details-box {\n    margin-top: 15px;\n    padding-top: 15px;\n    border-top: 1px solid #334155;\n}\n\n.details-grid {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n    gap: 8px;\n    color: #94a3b8;\n    font-size: 0.95rem;\n}\n\n/* Mobile Actions (FIXED SIZE) */\n.dl-mobile-actions {\n    display: flex;\n    justify-content: center;\n    gap: 10px;\n    margin-top: 15px;\n}\n\n.dl-mobile-actions .dl-btn {\n    flex: 0 1 auto;\n    min-width: 120px;\n    padding: 8px 20px;\n    text-align: center;\n}\n/* Responsive */\n@media (max-width: 768px) {\n    .dl-desktop-only-btns { display: none; }\n    .dl-item-main { flex-direction: row; }\n    .dl-mobile-actions { justify-content: space-around; }\n    .dl-mobile-actions .dl-btn { flex: 1; max-width: 150px; }\n    .details-grid { grid-template-columns: 1fr; }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
